"use client";

import { SessionProvider as SessionProviderBase } from "next-auth/react";

export default function SessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProviderBase>      
      {children}
    </SessionProviderBase>
  );
}
